import { render, staticRenderFns } from "./delivero_export.vue?vue&type=template&id=e5388af4&scoped=true&"
import script from "./delivero_export.vue?vue&type=script&lang=js&"
export * from "./delivero_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5388af4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5388af4')) {
      api.createRecord('e5388af4', component.options)
    } else {
      api.reload('e5388af4', component.options)
    }
    module.hot.accept("./delivero_export.vue?vue&type=template&id=e5388af4&scoped=true&", function () {
      api.rerender('e5388af4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/delivero/delivero_export.vue"
export default component.exports